var HSLtoRGB = require("./dist");

module.exports = HSLtoRGB;
